import { FieldProps } from 'formik';
import { ReactElement, useMemo } from 'react';
import DeclarationField from 'views/declarations/common/DeclarationField';
import { getFormikProps } from 'views/declarations/utils/form-utils';
import { useTranslation } from 'react-i18next';
import FormSelect from '../../../../../components/ui/composed/declarations/formSelect/DeclarationSelect';
import useCodelists from 'hooks/useCodelists';
import { ValidationSchema, validators } from '../validations/validations';

type Fields = 'modeCode';

export const inlandModeOfTransportBlockValidation: {
    childValidators: {
        'goodsShipment.consignment.departureTransportMeans': ValidationSchema<Fields>;
    };
} = {
    childValidators: {
        'goodsShipment.consignment.departureTransportMeans': {
            childValidators: {
                modeCode: [validators.number(), validators.exact(1)],
            },
        },
    },
};

interface Props extends BlockProps<Fields> {}

const InlandModeOfTransportBlock = ({
    path = 'goodsShipment.consignment.departureTransportMeans',
    fieldOptions,
}: Props): ReactElement => {
    const { t } = useTranslation('form');
    const { cdsCodelists } = useCodelists();

    const ucc = useMemo(() => '7/5', []);
    return (
        <DeclarationField pathPrefix={path} name="modeCode">
            {({ form, field }: FieldProps<any>) => (
                <FormSelect
                    refNumber={ucc}
                    label={t('InlandModeOfTransport')}
                    {...getFormikProps(field.name, form)}
                    selectOptions={cdsCodelists?.transportModeTypes}
                    condensed
                    codeValidation={[validators.number(), validators.exact(1)]}
                />
            )}
        </DeclarationField>
    );
};

export default InlandModeOfTransportBlock;
